import { Component, OnDestroy, OnInit } from '@angular/core';

@Component({
  selector: 'app-home5',
  templateUrl: './home5.component.html',
  styleUrls: ['./home5.component.scss']
})
export class Home5Component implements OnInit, OnDestroy {
  ngOnInit(): void {
    document.body.classList.add('home5-page');
  }

  ngOnDestroy(): void {
    document.body.classList.remove('home5-page');
  }
}
